import { FormGroup, FormParagraph } from '@ksyos/design-system';
import type { IOrganizationGeneralSettings } from '@common/validation/organization';
import { OrganizationKgoStatus } from '@common/enums';
import { EnumRadioGroup } from '@frontend/components/fields/EnumRadioGroup';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation, type ValidationErrors } from '@frontend/utils';

type OrganizationKgoStatusFormGroupProps = {
    canEdit: boolean;
    errors: ValidationErrors;
    kgoStatus: OrganizationKgoStatus | null | undefined;
    onChange: <Key extends keyof IOrganizationGeneralSettings>(
        key: Key,
        value: IOrganizationGeneralSettings[Key]
    ) => void;
};

export function OrganizationKgoStatusFormGroup({
    canEdit,
    errors,
    onChange,
    kgoStatus,
}: Readonly<OrganizationKgoStatusFormGroupProps>) {
    const translate = getSelectedLanguage();

    return (
        <FormGroup
            hasErrors={errors.has('kgoStatus')}
            isRequired={canEdit}
            label={translate.common.status}
        >
            {canEdit && (
                <EnumRadioGroup
                    enumObj={OrganizationKgoStatus}
                    error={getValidationErrorTranslation(errors.get('kgoStatus'))}
                    labels={translate.organization.kgoStatuses}
                    onChange={(value) => {
                        if (value) {
                            onChange('kgoStatus', value);
                        }
                    }}
                    sortByLabel={false}
                    value={kgoStatus}
                />
            )}
            {!canEdit && kgoStatus && <FormParagraph>{translate.organization.kgoStatuses[kgoStatus]}</FormParagraph>}
        </FormGroup>
    );
}
